"use client";
import { getShareLinkApi } from "@/api/config";
import { getCommissionApi } from "@/api/summary";
import { usePathname, useRouter } from "@/i18n/routing";
import { useUserInfoStore } from "@/stores/useUserInfoStore";
import { getToken } from "@/utils/Cookies";
import { copyText, flatPoint } from "@/utils/methods";
import { useRequest } from "ahooks";
import { Toast } from "antd-mobile";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import React from "react";
import styles from "./agent.module.scss";

const Agent = () => {
    const { userInfo } = useUserInfoStore();
    const token = getToken();
    const router = useRouter();
    const pathname = usePathname();
    const tc = useTranslations();
    React.useEffect(() => {
        init();
    }, []);

    const [BASE_URL, setBaseUrl] = React.useState("");
    const url = React.useMemo(() => {
        const shareUrl = `${BASE_URL}?share_id=${userInfo ? userInfo.referrer_code : "xxxxxx"}`;
        return encodeURIComponent(`${shareUrl}`);
    }, [BASE_URL, userInfo]);
    const TIME = 180000;

    const init = async () => {
        const res = await getShareLinkApi();
        if (res.code === 200) {
            const localUrl = `${window.location.protocol}//${window.location.hostname}`;
            const url = res.data.find((item) => item.type === 2)?.url ?? localUrl;
            setBaseUrl(url);
        }
    };
    const getCommission = () => {
        if (token) {
            return getCommissionApi().then((res) => {
                if (res.code === 200) return res.data;
            });
        }
        return Promise.resolve({
            commissar: 0,
            level: 0,
            withdrawal_commissions: 0,
            enable_receive: false,
            min_value: 0,
            max_value: 0,
        });
    };
    const { data: commissionData, run: commissionRun } = useRequest(getCommission, {
        pollingInterval: TIME,
        pollingErrorRetryCount: 3,
        staleTime: 5000,
    });

    const SHARE_SOURCE = React.useMemo(() => {
        return [
            {
                icon: "/summary/Facebook.webp",
                label: "Facebook",
                shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
            },
            {
                icon: "/summary/WhatsApp.webp",
                label: "WhatsApp",
                shareUrl: `https://api.whatsapp.com/send?text=${url}`,
            },
            {
                icon: "/summary/Telegram.webp",
                label: "Telegram",
                shareUrl: `https://t.me/share/url?url=${url}`,
            },
            {
                icon: "/summary/Twitter.webp",
                label: "X",
                shareUrl: `https://x.com/intent/post?text=${url}`,
            },
            {
                icon: "/summary/Email.webp",
                label: "Email",
                shareUrl: `mailto: ?&subject=&cc=&bcc=&body=${url}`,
            },
        ];
    }, [url]);

    const doCopy = (evt: any) => {
        (evt as any).stopPropagation();
        copyText(`${userInfo.referrer_code}`);
        Toast.show({ icon: "success", content: tc("SummaryPage.copySuc"), maskClickable: false });
    };

    return (
        <div className={styles.agent}>
            <div className="flex items-center justify-between">
                <div>
                    <span>Agente</span>
                    <span className="text-[.12rem]" onClick={doCopy}>
                        {" "}
                        Código de convite = {userInfo.referrer_code}{" "}
                        <i className="iconfont icon-fuzhi1 text-[#fff]"></i>
                    </span>
                </div>
                <div
                    className="flex items-center"
                    onClick={() => {
                        router.push(`/affiliate`);
                        // router.push(`/transactions?type=3`);
                    }}
                >
                    <span>Ver Mais</span>
                    <i className="iconfont icon-xiangyou1"></i>
                </div>
            </div>
            <div className="my-[.06rem] flex items-center justify-between rounded-[.1rem] bg-[#2b363f] p-[.06rem]">
                <div className="text-[#5f7880]">Comissäo direto de hoje</div>
                <div className="text-[0.15rem] text-[#f6cf1d]">
                    R${flatPoint(commissionData?.commissar || 0)}
                </div>
            </div>
            <div className="my-[.1rem] text-center">Compartilhamento Rapido</div>
            <div className="flex items-center justify-between rounded-[.1rem] bg-[#2b363f] p-[.1rem]">
                {SHARE_SOURCE.map((item) => {
                    return (
                        <a
                            href={token ? item.shareUrl : ""}
                            target={"_blank"}
                            className={clsx("mr-[.1rem] block w-[.4rem] text-center")}
                            key={item.label}
                        >
                            <img className={"w-[100%]"} src={item.icon} alt="" />
                            <span className="text-[.1rem] text-[#5f7880]">{item.label}</span>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default Agent;
